import React, { useMemo, useState } from "react";
import { C, font } from "../lib/styles.js";
import { getEqNames } from "../lib/equipment.js";
import { getApp } from "../lib/appRegistry.js";
import { jobAccess, visibleJobsNav } from "../apps/jobs/lib/jobAccess.js";
import { DataContextTestProvider } from "../context/DataContext.jsx";
import AppTopbar from "../components/AppTopbar.jsx";
import ScheduleView from "../apps/jobs/views/ScheduleView.jsx";
import { HOLD_JOBS, HOLD_QUOTES, HOLD_RECORDS, HOLD_ROSTER, holdsParams } from "./holdsSeed.js";

// No-login fixture for Jobs > Schedule: ?e2e=schedule&holds=1&role=admin|superadmin|crew|viewer.
// Renders the real topbar with the registry's Jobs nav filtered for the role (so
// the Schedule tab's visibility is the live rule) above the month view. The
// context carries `holds`, `holdsLoading`, and `role` the way the role-aware
// DataProvider does (role is the jobAccess role, so "superadmin" stays as-is);
// only admins receive savedQuotes. The specs pin the clock to
// holdsSeed.HOLDS_TODAY so the month is October 2026.

export default function E2EScheduleFixture() {
  const { holds, role } = holdsParams();
  const user = { role, name: `E2E ${role}`, email: `${role}@e2e.test` };
  const navItems = visibleJobsNav(getApp("jobs")?.navItems || [], role);
  const [activeNav, setActiveNav] = useState(Math.max(0, navItems.indexOf("Schedule")));

  const value = useMemo(() => {
    const access = jobAccess(role);
    return {
      jobs: holds ? HOLD_JOBS : [],
      savedQuotes: holds && access.isAdmin ? HOLD_QUOTES : [],
      holds: holds ? HOLD_RECORDS : [],
      holdsLoading: false,
      role: access.role,
      crewRoster: holds ? HOLD_ROSTER : [],
      equipmentMap: getEqNames(),
    };
  }, [holds, role]);

  return (
    <DataContextTestProvider value={value}>
      <div style={{ minHeight: "100vh", background: C.bg, fontFamily: font }}>
        <AppTopbar appName="Jobs" navItems={navItems} userInitials="E2" userEmail={user.email}
          onGoHome={() => {}} onSignOut={() => {}} activeNav={activeNav} onNavChange={setActiveNav} />
        <div className="app-content" style={{ padding: 24 }}>
          <div style={{ maxWidth: 1100, margin: "0 auto" }}>
            <div style={{ fontSize: 11, color: C.amber, textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: 12 }}>
              Local test mode: Schedule fixture ({role})
            </div>
            <ScheduleView navigate={() => {}} user={user} />
          </div>
        </div>
      </div>
    </DataContextTestProvider>
  );
}
